import { render, staticRenderFns } from "./AdministrativeReport.vue?vue&type=template&id=1ad1e816"
import script from "./AdministrativeReport.vue?vue&type=script&lang=js"
export * from "./AdministrativeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports